export const app = {
  logout: 'Logout',
  instructions: 'Instructions',
  help: 'Help',
  creditFreeze: 'https://www.opm.gov/suitability/suitea-notice-24-01.pdf',
  skip: 'Skip to form questions',
  banner: {
    title: 'An official website of the United States government',
    button: "Here's how you know",
    witty: "The .gov means it's official.",
    extension:
      'Federal government websites always use a .gov or .mil domain. Before sharing sensitive information online, make sure you\'re on a .gov or .mil site by inspecting your browser\'s address (or "location") bar.',
    ssl:
      "This site is also protected by an SSL (Secure Sockets Layer) certificate that's been signed by the U.S. government. The <strong>https://</strong> means all transmitted data is encrypted  — in other words, any information or browsing history that you provide is transmitted securely.",
  },
  logotext: 'eApp',
  optional: '(Optional)',
  title: 'Welcome to NBIS eApp',
};
